@if (loading) {
  <div class="loader-center">
    <div style="padding-bottom: 10px; padding-left: 10px;"><img src='assets/spinner.gif'></div>
  </div>
}
